'use client';

import { SDK } from '@absmartly/javascript-sdk';
import { datadogRum } from '@datadog/browser-rum';
import type { ABSmartlyEventLogger, ABSmartlySDKOptions, ContextData } from '../types';
import type { DeviceType } from './deviceType';
import setupForcedVariants from './variants';

const defaultEventLogger: ABSmartlyEventLogger = (_, eventName, data) => {
  if (eventName == 'error') {
    console.error(data);
  }
};

export type HydrateContextParams = {
  sdkConfig: ABSmartlySDKOptions;
  contextData?: ContextData;
  anonymousId: string | null;
  deviceType: DeviceType;
  experimentPrefix?: string;
};

export const hydrateClientContext = ({
  sdkConfig,
  contextData,
  anonymousId,
  deviceType,
  experimentPrefix = 'test_',
}: HydrateContextParams) => {
  if (!contextData || !anonymousId) {
    return null;
  }
  const handleError = (error: unknown) => {
    datadogRum.addError(error, { message: 'ABSmartly failed to hydrate on client' });
  };
  try {
    const sdk = new SDK({
      ...sdkConfig,
      eventLogger: sdkConfig.eventLogger ?? defaultEventLogger,
    });
    const clientContext = sdk.createContextWith(
      {
        units: {
          anonymous_id: anonymousId,
        },
      },
      contextData,
    );

    clientContext.ready().catch(handleError);
    clientContext.attributes({
      url: window.location.href,
      page_url: window.location.href,
      page_path: window.location.pathname,
      user_agent: navigator.userAgent,
      environment: sdkConfig.environment,
      device_type: deviceType,
    });
    setupForcedVariants(clientContext, experimentPrefix);
    return clientContext;
  } catch (error) {
    console.error('ABSmartly failed to hydrate on client:', error);
    handleError(error);
    return null;
  }
};
